import { t } from 'ttag';

const NOT_ASSIGNED_MESSAGE = t`This study belongs to a different facility.`;

export { NOT_ASSIGNED_MESSAGE };
